var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"TermsText",attrs:{"id":"privacy-policy"},domProps:{"innerHTML":_vm._s(_vm.privacy)}})}
var staticRenderFns = []

export { render, staticRenderFns }